import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link, Switch
} from 'react-router-dom'
import testmain from './pages/Testmain'
import notfound from './pages/notfound'
import Login from './pages/login'
import Signup from './pages/signup'
import { Menu, Dropdown } from 'semantic-ui-react'
import axios from 'axios'
import Background from './images/webneat-min.jpg'

import 'semantic-ui-css/semantic.min.css';

const Home = () => (
  <div style={{textAlign: 'center', position: 'absolute', top: '50%', left: '50%', margin: '-180px 0 0 -150px'}}>
    <Login />
  </div>
)

const preSignup = () => (
  <div style={{textAlign: 'center', position: 'absolute', top: '50%', left: '50%', margin: '-270px 0 0 -150px'}}>
    <Signup />
  </div>
)

class BasicExample extends Component {
  state = {
    loggedIn: false,
    username: ''
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  LogOut() {
    document.cookie = 'loggedIn=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'loggedInUser=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'loggedInId=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'failedInd=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.location.href = "/"
  }

  getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  componentDidMount = () => {
    var path
    window.location.pathname.substring(1) === '' ? path = 'landing' : path = window.location.pathname.substring(1)

    this.setState({activeItem: path})

    // axios.defaults.baseURL = 'http://127.0.0.1:47000';
    axios.defaults.baseURL = 'https://training.gsmsaleskc.com';

    var isAuth = false;

    var loggedIn = this.getCookie("loggedIn")
    var hasFailed = this.getCookie("hasFailed")

    if (loggedIn && !hasFailed) isAuth = true;
    var username = this.getCookie("loggedInUser")
    this.setState({username: username})



    if (isAuth) {
      //console.log("user detected")
    }


  }

  render() {
    const { activeItem, username } = this.state
    if (activeItem === 'signup' || activeItem === 'landing') {
      var homeStyle = {
        backgroundImage: 'url(' + Background + ')',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      }
      var menuBarStyle = {
        background: 'none', opacity: '0', pointerEvents: 'none'
      }
    } else {
      var homeStyle = {height: '100%', backgroundColor: '#e1fcff73'} //eslint-disable-line
      var menuBarStyle //eslint-disable-line
    }

    return (
      <Router>
      <div style={homeStyle}>
          <Menu style={menuBarStyle}>
            <Link to="/"><Menu.Item header onClick={this.handleItemClick}>GSM - Training</Menu.Item></Link>
            <Link to="/test"><Menu.Item name='test' active={activeItem === "test"} onClick={this.handleItemClick}>Test</Menu.Item></Link>
            <Menu.Menu position='right'>
              <Dropdown item text={username}>
                <Dropdown.Menu>
                  <Dropdown.Header>{username}</Dropdown.Header>
                  <Dropdown.Item>Settings</Dropdown.Item>
                  <Dropdown.Item onClick={this.LogOut}>Log Out</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Menu>
          </Menu>

          {/*<Route exact path="/" component={Home} /> */}

          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/test" component={testmain} />
            <Route exact path="/signup" component={preSignup} />
            <Route component={notfound} />
          </Switch>
        </div>
    </Router>
  )
  }

}
export default BasicExample



// WEBPACK FOOTER //
// ./src/App.js